import styled, { css } from 'styled-components';
import IconCloseFilled from '../../assets/svgs/close-filled.svg';

import Theme from '../../theme';
import { remCalc } from '@lux/helpers';

export const layoutProps = {
  height: 40,
  padV: 8,
  padH: 12
};

export const IconButtonContainer = styled.div`
  height: ${remCalc(layoutProps.height)};
  width: ${remCalc(layoutProps.height)};
  box-sizing: border-box;
  position: absolute;
  top: 0;
  right: ${props => (props.stickyRight ? '40px' : '0px')};
  padding: ${remCalc(layoutProps.padH)};
`;

export const IconButton = styled.div`
  cursor: pointer;
  position: absolute;
  top: 5%;
  left: 5%;
  height: 90%;
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  &:active {
    background: ${Theme.colours.grey_e1};
  }
  transition: background-color 100ms;
`;

export const CloseIcon = styled(IconCloseFilled)`
  fill: ${Theme.colours.grey_c6};

  ${/* sc-selector */ IconButton}:hover & {
    fill: ${Theme.colours.grey_70};
  }
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const HintMessage = styled.div`
  font-family: ${Theme.fonts.families.AvenirBook};
  font-size: ${Theme.fonts.sizes.small};
  margin: ${remCalc(8)} 0 ${remCalc(16)};
  color: ${props =>
    props.validation
      ? Theme.states[props.validation].colour
      : Theme.colours.grey_c6};
`;

export default {
  Input: styled.input`
    && {
      font-family: ${Theme.fonts.families.AvenirBook};
      font-size: ${Theme.fonts.sizes.regular};
      ${Theme.styles.componentSmallRadius};
      height: ${remCalc(layoutProps.height)};
      border: ${props =>
        props.validation
          ? `1px solid ${Theme.states[props.validation].colour}`
          : `1px solid ${Theme.colours.grey_c6}`};
      box-shadow: none;
      padding: ${remCalc(layoutProps.padV)} ${remCalc(layoutProps.padH)};

      ${props =>
        !props.showClear && !props.rightIcon
          ? null
          : css`
              padding-right: ${props.showClear && props.rightIcon
                ? remCalc(2 * layoutProps.height)
                : remCalc(layoutProps.height)};
            `};

      width: 100%;
      margin: ${props => (props.hintMessage ? '0' : `0 0 ${remCalc(16)} 0`)};
      color: ${Theme.colours.black};
      display: block;

      ${props =>
        !props.isEditable
          ? css`
              font-size: ${Theme.fonts.sizes.large};
              border: none;
              padding: ${remCalc(8)} 0;
              color: ${Theme.colours.black};
            `
          : css`
              &.disabled,
              &[disabled] {
                background: ${Theme.colours.white};
                border: 1px solid ${Theme.colours.grey_cc};
                color: ${Theme.colours.grey_cc};
                cursor: default;
                transition: border-color 0.15s linear, background 0.15s linear;
              }
            `};

      &::placeholder {
        color: ${Theme.colours.grey_c6};
        font-size: ${remCalc(16)};
      }

      &:focus {
        border-color: ${props =>
          props.validation
            ? Theme.states[props.validation].colour
            : Theme.colours.linkblue};
        outline: 0;
      }
    }
  `
};
